import createApiClient from "./api";

const client = createApiClient();

export const api = {
  createApiCredentials: ({ orgId, payload }) =>
    client
      .post(`admin/organizations/${orgId}/api-credentials`, payload)
      .then(({ data }) => data),

  getApiCredentials: ({ orgId, search, perPage, currentPage }) =>
    client
      .get(
        `admin/organizations/${orgId}/api-credentials?search=${search}&perPage=${perPage}&page=${currentPage}`
      )
      .then(({ data }) => data),
};
